import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 54344 47786"
    {...props}
  >
    <defs>
      <style>
        {
          //   ".str0{stroke:#000;stroke-width:790.313}.str1{stroke:#1c1b17;stroke-width:602.219}.fil0{fill:#2b2a29}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528323146384">
        <path
          d="M50967 2324H3375c-206 0-373-167-373-374 0-206 167-373 373-373h47592c207 0 374 167 374 373 0 207-167 374-374 374z"
          className="fill stroke1"
          style={{
            strokeWidth: 790.313,
          }}
        />
        <path
          d="M52393 1047c-499 0-903 406-903 903 0 498 404 904 902 904 499 0 904-406 904-904 0-497-405-903-903-903zm0 2553c-910 0-1650-740-1650-1650 0-909 740-1649 1649-1649 911-1 1650 740 1650 1649 0 910-739 1650-1649 1650z"
          className="fill stroke1"
          style={{
            strokeWidth: 602.219,
          }}
        />
        <path
          d="M38220 43994c1530 0 2321 759 3019 1429 684 656 1274 1222 2505 1222 1230 0 1820-566 2503-1222 594-570 1267-1216 2408-1386 137-20 239-141 239-283V3905c-984 103-1520 617-2130 1203-698 670-1489 1429-3020 1429-1532 0-2324-759-3022-1429-682-655-1272-1222-2502-1222-1232 0-1821 567-2505 1222-697 670-1489 1429-3020 1429s-2322-759-3020-1429c-683-655-1273-1222-2504-1222s-1820 567-2503 1222c-699 670-1490 1429-3021 1429s-2322-759-3020-1429c-683-656-1273-1222-2504-1222-1230 0-1820 567-2503 1222-698 670-1489 1429-3020 1429-1532 0-2323-759-3021-1429-609-586-1146-1100-2131-1203v39849c0 141 104 262 240 283 1141 170 1814 816 2408 1386 683 655 1273 1222 2504 1222 1230 0 1821-567 2503-1222 698-670 1489-1429 3020-1429s2322 759 3021 1429c683 655 1273 1222 2503 1222 1231 0 1821-567 2504-1222 697-670 1489-1429 3020-1429s2323 759 3021 1429c682 655 1272 1222 2503 1222s1820-566 2504-1222c698-670 1489-1429 3021-1429zm5524 3397c-1532 0-2324-759-3022-1430-682-655-1272-1221-2502-1221-1232 0-1821 566-2505 1221-697 671-1489 1430-3020 1430s-2322-759-3020-1430c-683-655-1273-1221-2504-1221s-1820 566-2503 1221c-699 671-1490 1430-3021 1430s-2322-759-3020-1430c-683-655-1273-1221-2504-1221-1230 0-1820 566-2503 1221-698 671-1489 1430-3020 1430-1532 0-2323-759-3021-1430-563-540-1095-1051-2000-1186-500-74-877-513-877-1021V3140h373c1532 0 2323 759 3021 1430 683 655 1273 1221 2504 1221 1230 0 1821-566 2503-1221 698-671 1489-1430 3020-1430s2322 759 3021 1430c683 655 1273 1221 2503 1221 1231 0 1821-566 2504-1221 697-671 1489-1430 3020-1430s2323 759 3021 1430c682 655 1272 1221 2503 1221s1820-566 2504-1221c698-671 1489-1430 3021-1430 1530 0 2321 759 3019 1430 684 656 1274 1221 2505 1221 1230 0 1820-565 2503-1221 698-671 1490-1430 3021-1430h373v40614c0 508-377 948-876 1021-905 135-1438 646-2001 1186-698 671-1489 1431-3020 1430z"
          className="fill stroke1"
          style={{
            strokeWidth: 790.313,
          }}
        />
        <path
          d="M38220 29702c-207 0-374-168-374-374v-7835c0-206 167-373 374-373 206 0 373 167 373 373v7835c0 206-167 374-373 374zM38220 19225c-207 0-374-167-374-373v-7834c0-207 167-373 374-373 206-1 373 166 373 373v7834c0 206-167 374-373 373z"
          className="fill stroke1"
          style={{
            strokeWidth: 790.313,
          }}
        />
        <path
          d="M1950 1047c-497 0-903 406-903 903 0 498 406 904 903 904 498 0 904-406 904-904 0-497-406-903-904-903zm0 2553c-908 0-1649-740-1649-1650 0-909 741-1649 1649-1649 911-1 1650 740 1650 1649 0 910-739 1650-1650 1650z"
          className="fill stroke1"
          style={{
            strokeWidth: 602.219,
          }}
        />
        <path
          d="M15954 42807c-206 0-373-167-373-373V29328c0-206 167-373 373-373 207 0 374 167 374 373v13106c0 206-168 373-374 373zM27171 43159c-206 0-373-167-373-373V22549c0-205 167-373 373-373s374 168 374 374v20236c0 206-168 373-374 373zM38220 43159c-207 0-374-167-374-373V32668c0-206 167-373 374-373 206 0 373 167 373 373v10118c0 206-167 373-373 373z"
          className="fill stroke1"
          style={{
            strokeWidth: 790.313,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
